import { Organisatie, Rijtijd, TvvStandaardRoute, Voertuigsoort, VoertuigsoortDisplay } from "@/entities/tvv";
import { Badge } from "@/shared/components";

type RouteTagsProps = {
    organisatie: Organisatie;
    voertuigSoort: Voertuigsoort;
    totaleRijtijd?: number | undefined;
    ovLijnNummer?: string;
    busFrequentie?: number;
};

export function RouteTags({ organisatie, voertuigSoort, ovLijnNummer, totaleRijtijd, busFrequentie }: Readonly<RouteTagsProps>) {
    return (
        <div className="flex gap-2">
            <Badge variant="blue-subtle" size="m" data-testid="badge-organisatie">
                {TvvStandaardRoute.formatOrganisatie(organisatie)}
            </Badge>
            <Badge variant="blue-subtle" size="m" data-testid="badge-voertuig">
                {VoertuigsoortDisplay[voertuigSoort] ?? voertuigSoort}
            </Badge>
            {ovLijnNummer && (
                <Badge variant="blue-subtle" size="m">
                    {ovLijnNummer}
                </Badge>
            )}
            {totaleRijtijd && (
                <Badge variant="blue-subtle" size="m" data-testid="badge-rijtijd-frequentie">
                    Rijtijd {Rijtijd.formatRijtijd(totaleRijtijd)}
                    {!!busFrequentie && ` | ${busFrequentie} per uur`}
                </Badge>
            )}
        </div>
    );
}
